/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @link https://github.com/invoiceninja/invoiceninja source repository
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const defaultSettings = {
  industry_id: '',
  size_id: '',
  lock_invoices: '',
  show_all_tasks_client_portal: '',
  portal_design_id: '',
  timezone_id: '',
  date_format_id: '',
  language_id: '',
  company_gateway_ids: '',
  currency_id: '',
  custom_value1: '',
  custom_value2: '',
  custom_value3: '',
  custom_value4: '',
  default_task_rate: 0,
  payment_terms: '',
  custom_message_dashboard: '',
  custom_message_unpaid_invoice: '',
  custom_message_paid_invoice: '',
  custom_message_unapproved_quote: '',
  entity_send_time: 0,
  quote_footer: '',
  counter_number_applied: '',
  quote_number_applied: '',
  invoice_number_pattern: '',
  invoice_number_counter: 0,
  recurring_invoice_number_pattern: '',
  recurring_invoice_number_counter: 0,
  quote_number_pattern: '',
  quote_number_counter: 0,
  client_number_pattern: '',
  client_number_counter: 0,
  credit_number_pattern: '',
  credit_number_counter: 0,
  task_number_pattern: '',
  task_number_counter: 0,
  expense_number_pattern: '',
  expense_number_counter: 0,
  recurring_expense_number_pattern: '',
  recurring_expense_number_counter: 0,
  recurring_quote_number_pattern: '',
  recurring_quote_number_counter: 0,
  vendor_number_pattern: '',
  vendor_number_counter: 0,
  ticket_number_pattern: '',
  ticket_number_counter: 0,
  payment_number_pattern: '',
  payment_number_counter: 0,
  project_number_pattern: '',
  project_number_counter: 0,
  postmark_secret: '',
  mailgun_secret: '',
  mailgun_domain: '',
  mailgun_endpoint: '',
  purchase_order_number_pattern: '',
  purchase_order_number_counter: 0,
  recurring_number_prefix: '',
  reset_counter_frequency_id: 0,
  reset_counter_date: '',
  counter_padding: 0,
  auto_bill: '',
  auto_bill_date: '',
  invoice_terms: '',
  quote_terms: '',
  invoice_taxes: 0,
  invoice_design_id: '',
  quote_design_id: '',
  credit_design_id: '',
  purchase_order_design_id: '',
  purchase_order_footer: '',
  purchase_order_terms: '',
  purchase_order_public_notes: '',
  invoice_footer: '',
  credit_footer: '',
  credit_terms: '',
  invoice_labels: '',
  tax_name1: '',
  tax_rate1: 0,
  tax_name2: '',
  tax_rate2: 0,
  tax_name3: '',
  tax_rate3: 0,
  payment_type_id: '',
  valid_until: '',
  email_sending_method: '',
  gmail_sending_user_id: '',
  reply_to_email: '',
  reply_to_name: '',
  bcc_email: '',
  email_style: '',
  email_style_custom: '',
  email_subject_invoice: '',
  email_subject_quote: '',
  email_subject_credit: '',
  email_subject_payment: '',
  email_subject_payment_partial: '',
  email_subject_statement: '',
  email_subject_purchase_order: '',
  email_template_purchase_order: '',
  email_template_invoice: '',
  email_template_credit: '',
  email_template_quote: '',
  email_template_payment: '',
  email_template_payment_partial: '',
  email_template_statement: '',
  email_subject_reminder1: '',
  email_subject_reminder2: '',
  email_subject_reminder3: '',
  email_subject_reminder_endless: '',
  email_template_reminder1: '',
  email_template_reminder2: '',
  email_template_reminder3: '',
  email_template_reminder_endless: '',
  email_signature: '',
  email_subject_custom1: '',
  email_subject_custom2: '',
  email_subject_custom3: '',
  email_template_custom1: '',
  email_template_custom2: '',
  email_template_custom3: '',
  num_days_reminder1: 0,
  num_days_reminder2: 0,
  num_days_reminder3: 0,
  schedule_reminder1: '',
  schedule_reminder2: '',
  schedule_reminder3: '',
  reminder_send_time: 0,
  late_fee_amount1: 0,
  late_fee_amount2: 0,
  late_fee_amount3: 0,
  late_fee_percent1: 0,
  late_fee_percent2: 0,
  late_fee_percent3: 0,
  endless_reminder_frequency_id: '',
  late_fee_endless_amount: 0,
  late_fee_endless_percent: 0,
  name: '',
  company_logo: '',
  website: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  postal_code: '',
  phone: '',
  email: '',
  country_id: '',
  vat_number: '',
  id_number: '',
  page_size: '',
  page_layout: '',
  font_size: 0,
  primary_font: '',
  secondary_font: '',
  primary_color: '',
  secondary_color: '',
  page_numbering_alignment: '',
  portal_custom_head: '',
  portal_custom_css: '',
  portal_custom_footer: '',
  portal_custom_js: '',
  client_portal_terms: '',
  client_portal_privacy_policy: '',
  client_portal_under_payment_minimum: 0,
  use_credits_payment: '',
  email_from_name: '',
  first_month_of_year: '',
  qr_iban: '',
  besr_id: '',
  company_logo_size: '',
  client_initiated_payments_minimum: 0,
  e_invoice_type: '',
  default_expense_payment_type_id: '',
  classification: '',
  e_quote_type: '',
  brevo_secret: '',
};
